import BeSimpleAPI from '@/providers/api/';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_FMMODULE_API_URL),
    'invoices': {
        items: [],
        item: {}
    },
    'companyusers': {
        items: [],
        item: {}
    },
    'approvals': [],
    'invoices/pages': [],
    'documenten/onbekend': []
}

const getters = {
    //list getters
    invoices: state => state['invoices'].items,
    companyusers: state => state['companyusers'].items,
    approvals: (state) => state.approvals,

    //single getters
    invoice: state => state['invoices'].item,
}

const actions = {
    ...baseActions,
    addApproval(context, newApproval){
        context.commit('ADD_TO_APPROVAL', newApproval);
    },
    clearApprovals(context){
        context.commit('CLEAR_APPROVAL');
    },
    setApproval(context, invoice){
        context.commit('SET_APPROVAL', invoice);
    }
}

const mutations = {
    ...baseMutations,
    ADD_TO_APPROVAL(state, payload){
        state.approvals = [...state.approvals, payload]
    },
    CLEAR_APPROVAL(state){
        state.approvals = []
    },
	SET_APPROVAL(state, invoice) {
		state.invoices.items = state.invoices.items.filter(item => item !== invoice)
	}
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}